import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { searchPaymentRequests } from '@src/api'
import { DefaultApiSearchPaymentRequestsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { canReadAllPaymentRequest } from '@src/utils'

export const useFetchSearchPaymentRequests = (
  params: DefaultApiSearchPaymentRequestsRequest
) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!params.organizationId && canReadAllPaymentRequest(),
    queryFn: () => searchPaymentRequests(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_SEARCH_PAYMENT_REQUESTS, params],
    placeholderData: keepPreviousData,
  })
}
